import React from 'react';
import { Check, ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="bg-gradient-to-b from-[#1F3D2B] to-[#2E5A3E] py-6 md:py-8 px-3 border-b border-[#1F3D2B]" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-144">
          💣 OFERTA ESPECIAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-stretch" data-id="element-145">
          {/* Kit Completo */}
          <div className="bg-[#0B1F17] rounded-xl p-4 flex flex-col h-full border border-[#1F3D2B] shadow-lg" data-id="element-146">
            <h3 className="text-base md:text-lg font-black text-white uppercase mb-2 text-center" data-id="element-147">
              🎯 KIT COMPLETO
            </h3>
            <div className="text-center mb-3" data-id="element-148">
              <div className="text-3xl md:text-4xl font-black text-[#D4A843]" data-id="element-149">
                $19.990
              </div>
            </div>
            <ul className="space-y-2 mb-4 flex-grow" data-id="element-150">
              <li className="flex items-center gap-2 text-[#BFC9C5] text-xs md:text-sm font-bold" data-id="element-151">
                <Check className="w-4 h-4 text-[#74C69D] flex-shrink-0" strokeWidth={3} data-id="element-152" />
                6 tomos completos
              </li>
              <li className="flex items-center gap-2 text-[#BFC9C5] text-xs md:text-sm font-bold" data-id="element-153">
                <Check className="w-4 h-4 text-[#74C69D] flex-shrink-0" strokeWidth={3} data-id="element-154" />
                4 bonos de regalo
              </li>
            </ul>
            <CTAButton href="https://checkout.kitonline.shop/cart/47882053779694:1" variant="primary" fullWidth className="py-3 text-sm" data-id="element-155">
              COMPRAR AHORA
            </CTAButton>
          </div>

          {/* Kit + Sistema Pro */}
          <div className="bg-[#0F241C] rounded-xl p-4 flex flex-col h-full relative border-2 border-[#D4A843] glow-gold shadow-2xl transform md:-translate-y-2" data-id="element-156">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4A843] text-white font-black px-4 py-0.5 rounded-full text-[10px] md:text-xs tracking-widest uppercase whitespace-nowrap z-10 shadow-lg" data-id="element-157">
              ⭐ RECOMENDADO
            </div>

            <h3 className="text-base md:text-lg font-black text-white uppercase mb-2 mt-1 text-center" data-id="element-158">
              🚀 KIT + SISTEMA PRO
            </h3>

            <div className="text-center mb-3" data-id="element-159">
              <div className="text-3xl md:text-4xl font-black text-[#D4A843]" data-id="element-160">
                $29.990
              </div>
            </div>

            <p className="text-[#74C69D] font-black text-xs mb-2 border-b border-[#1F3D2B] pb-2 text-center" data-id="element-161">
              ✔ Todo lo anterior +
            </p>

            <div className="bg-[#102A1F] rounded-lg p-3 mb-3 border border-[#1F3D2B] flex-grow" data-id="element-162">
              <h4 className="font-black text-[#D4A843] text-xs mb-2 uppercase text-center" data-id="element-163">
                💥 SISTEMA PRO DE CLASES FORESTALES
              </h4>
              <ul className="space-y-1.5" data-id="element-164">
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-165">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-166" />
                  Clases listas paso a paso
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-167">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-168" />
                  Actividades imprimibles
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-169">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-170" />
                  Evaluaciones con respuestas
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-171">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-172" />
                  Proyectos prácticos
                </li>
              </ul>
            </div>

            <p className="text-center text-[#BFC9C5] font-black text-[10px] md:text-xs mb-3 leading-tight" data-id="element-173">
              👉 Para que tus clases no solo estén armadas…
              <br data-id="element-174" />
              sino que sean profesionales
            </p>

            <CTAButton href="https://checkout.kitonline.shop/cart/47882054566126:1" variant="primary" fullWidth className="py-3 text-sm" data-id="element-175">
              COMPRAR AHORA
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 text-[#BFC9C5] text-[10px] md:text-xs font-bold mt-6" data-id="element-176">
          <div className="flex items-center gap-1" data-id="element-177">
            <LockIcon className="w-4 h-4 text-[#74C69D]" data-id="element-178" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-179">
            <ZapIcon className="w-4 h-4 text-[#74C69D]" data-id="element-180" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-1" data-id="element-181">
            <ShieldCheckIcon className="w-4 h-4 text-[#74C69D]" data-id="element-182" /> Garantía 7
            días
          </div>
          <div className="flex items-center gap-1" data-id="element-183">
            <CreditCardIcon className="w-4 h-4 text-[#74C69D]" data-id="element-184" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}